import { Box, useThemeUI, Text } from "theme-ui";
import { useState } from "react";
import { useDispatch } from "react-redux";
// import filter from "lodash/fp/filter";
import flow from "lodash/fp/flow";
// import get from "lodash/fp/get";
import keys from "lodash/fp/keys";
import map from "lodash/fp/map";
// import pick from "lodash/fp/pick";
// import some from "lodash/fp/some";

import { updateUserChoiceValues } from "store/app/appSlice";
// import { useTranslation } from "hooks";
import { Button } from "components";
import ModalCenterEnlarged from "../ModalCenterEnlarged";
import * as styles from "./ModalSelectProCustom.styles";

export default function ModalSelectProCustom({
  isTopMostModal,
  onClose,
  customisation,
  title,
  text,
  description,
}) {
  const {
    theme: { isDesktop, isTablet, isMobile },
  } = useThemeUI();

  const dispatch = useDispatch();

  // Defines what Goalie Products the user has selected to cutomise, (e.g Gloves and Blocker only)
  const initialUserChoices = customisation.fields.reduce(
    (acc, curr) => ({
      ...acc,
      [curr.name]: curr.defaultValue,
    }),
    {}
  );

  const [formValues, setFormValues] = useState({
    ...initialUserChoices,
  });

  const dispatchUpdateUserChoiceValues = (fieldValue) => {
    dispatch(updateUserChoiceValues(fieldValue));
  };
  //defines what values of Graphic to be submitted into userChoiceValues
  const userProCustomChoiceValuesToSubmit = (values) =>
    flow(
      keys,
      map((field) => ({
        name: field,
        value: values[field],
      }))
    )(values);
  console.log(userProCustomChoiceValuesToSubmit(formValues));
  // console.log(formValues);
  //updates the userChoice values submitted by clicking the button
  const handleSubmit = (evt) => {
    evt.preventDefault();
    flow(
      userProCustomChoiceValuesToSubmit,
      dispatchUpdateUserChoiceValues,
      onClose
    )(formValues);
  };

  return (
    <>
      <ModalCenterEnlarged
        isTopMostModal={isTopMostModal}
        onClose={onClose}
        disableEscapeKey
        background={"transparent"}
        boxShadow={"none"}
      >
        <Box sx={styles.graphicContent}>
          <Box sx={styles.graphicTerms}>
            <Text variant="h5" sx={styles.graphicTitle}>
              {title}
            </Text>
            <Text variant="h3Light" sx={styles.graphicText}>
              {text}
            </Text>
            <Text variant="h2Light" sx={styles.graphicDescription}>
              {description}
            </Text>
          </Box>
          <Box
            as="form"
            onSubmit={handleSubmit}
            sx={styles.contentContainer({ isMobile, isDesktop, isTablet })}
          >
            <Box sx={styles.gearSelectorContainer({ isMobile })}>
              {customisation.fields[0].options.map(
                ({ name, label, title, value, imageURLValue }) => {
                  return (
                    <Box key={label} sx={styles.graphic}>
                      <Box sx={styles.imagesContainer}>
                        <Box
                          sx={styles.image({
                            backgroundImageUrl: imageURLValue,
                            isMobile,
                          })}
                        />
                      </Box>
                      <Box sx={styles.graphicLabel}>
                        <Button
                          type="submit"
                          variant="primary"
                          size="medium"
                          isRound
                          theme="dark"
                          onClick={() => {
                            setFormValues((prevState) => ({
                              ...prevState,
                              [name]: value,
                            }));
                          }}
                        >
                          {title}
                        </Button>
                      </Box>
                    </Box>
                  );
                }
              )}
            </Box>
          </Box>
        </Box>
      </ModalCenterEnlarged>
    </>
  );
}
